import { Endpoint } from '../endpoint';
import { BrandResponse, BrandId } from '@business/entities/brand';
import { CompanyId } from '@business/entities/companies';

export function fetchBrands(companyId: CompanyId) {
  return Endpoint.get<BrandResponse[]>(`@gc/brands/${companyId}`);
}

export function fetchBrand(id: BrandId) {
  return Endpoint.get<BrandResponse>(`@gc/brands/brand/${id}`);
}

export function createBrand(companyId: CompanyId, brand: Partial<BrandResponse>) {
  return Endpoint.post<BrandResponse>(`@gc/brands/${companyId}`, { data: { ...brand } });
}

export function updateBrand(id: BrandId, brand: Partial<BrandResponse>) {
  return Endpoint.patch<BrandResponse>(`@gc/brands/${id}`, { data: { ...brand } });
}

export function deleteBrand(newBrand: BrandId, BrandId: BrandId) {
  return Endpoint.delete<void>(`@gc/brands/${BrandId}`, { data: { newBrand } });
}
